import { exportTermSheetToDriveApi } from 'api/termSheetApi';
import { buildTermSheetDocxBlob } from './exportTermSheetDocx';
import { buildTermSheetDriveFilename } from './exportTermSheetOdt';

export async function exportTermSheetToDrive({
  customerId,
  fields,
  name,
  customerName,
  sequenceNumber = null,
}) {
  const docxBlob = await buildTermSheetDocxBlob(fields);
  const docxFilename = buildTermSheetDriveFilename({
    customerName,
    name,
    sequenceNumber,
    extension: '.docx',
  });
  return exportTermSheetToDriveApi({
    customerId,
    docxBlob,
    docxFilename,
  });
}
